<template>
    <div class="DashboardProfileView">
        <ProfileHeader />
        <ProfileMenu :tab-id="tabId" />

        <LifeProgressPanel v-if="tabId === 'life'" />
        <WeeklyProgressPanel v-else-if="tabId === 'week'" />
        <FollowingLifeskillsPanel v-else-if="tabId === 'follow'" />
        <TeamPanel v-else-if="tabId === 'team'" />
        <TeamChallengeResults v-else-if="tabId === 'results'" />
    </div>
</template>

<script>
import LifeProgressPanel from './LifeProgressPanel';
import WeeklyProgressPanel from './WeeklyProgressPanel';
import FollowingLifeskillsPanel from './FollowingLifeskillsPanel';
import TeamPanel from '@/modules/team/TeamPanel';
import ProfileHeader from '@/modules/dashboard/views/DashboardProfileView/ProfileHeader';
import ProfileMenu from '@/modules/dashboard/views/DashboardProfileView/ProfileMenu';
import TeamChallengeResults from '@/modules/dashboard/views/DashboardProfileView/TeamChallengeResults';

export default {
    components: {
        LifeProgressPanel,
        WeeklyProgressPanel,
        FollowingLifeskillsPanel,
        TeamPanel,
        ProfileHeader,
        ProfileMenu,
        TeamChallengeResults
    },
    props: {
        tabId: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.DashboardProfileView {
    color: white;
    overflow-y: auto;
}
</style>
